import React from 'react';
import { createPortal } from 'react-dom';
import { Save, CloudUpload, CheckCircle2 } from 'lucide-react';

const fmtTime = (iso) => (iso ? new Date(iso).toLocaleTimeString('no-NO', { hour: '2-digit', minute: '2-digit' }) : '');

export const SaveButton = ({ onClick, saving, disabled, testid, className = '' }) => (
  <button type="button" onClick={onClick} disabled={saving || disabled} data-testid={testid}
    className={`flex items-center justify-center gap-2 px-5 h-11 bg-yellow-500 text-gray-900 rounded-lg font-semibold hover:bg-yellow-400 disabled:bg-gray-600 disabled:text-gray-400 touch-manipulation ${className}`}>
    <Save className="w-4 h-4" />
    {saving ? 'Lagrer...' : 'Lagre resultater'}
  </button>
);

export const SyncStatus = ({ syncState, draft }) => {
  if (draft?.autosaved_at && !draft?.dirty) {
    return (
      <span className="flex items-center gap-1 text-xs text-green-300" data-testid="register-sync-status">
        <CheckCircle2 className="w-3.5 h-3.5" />Autolagret som resultater kl. {fmtTime(draft.autosaved_at)}
      </span>
    );
  }
  return (
    <span className="flex items-center gap-1 text-xs text-gray-400" data-testid="register-sync-status">
      <CloudUpload className="w-3.5 h-3.5" />
      {syncState === 'saving' ? 'Mellomlagrer…' : syncState === 'error' ? 'Kunne ikke mellomlagre – prøver igjen' : 'Mellomlagret på alle enhetene dine'}
    </span>
  );
};

export const MerkeRegisterSaveBar = ({ seriesCount, onSave, saving, syncState, draft }) => createPortal(
  <div className="fixed left-1/2 -translate-x-1/2 bottom-24 xl:bottom-6 w-[calc(100%-1.5rem)] max-w-3xl z-[60] bg-gray-900/95 backdrop-blur border border-yellow-500/50 rounded-xl shadow-2xl p-2.5 flex items-center gap-3"
    data-testid="register-floating-save-bar">
    <div className="flex-1 min-w-0">
      <p className="text-sm text-yellow-300 font-semibold" data-testid="register-unsaved-count">
        {seriesCount} serie{seriesCount === 1 ? '' : 'r'} {draft?.autosaved_at && !draft?.dirty ? '– autolagret, ikke ferdigstilt' : 'ikke lagret'}
      </p>
      <SyncStatus syncState={syncState} draft={draft} />
    </div>
    <SaveButton onClick={onSave} saving={saving} testid="register-floating-save-btn" />
  </div>,
  document.body
);

export default MerkeRegisterSaveBar;
